import Vue from 'vue';
import WPXForm from '@/components/templates/WPXForm';

Vue.component('wpx-form', WPXForm)
